import { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { yupResolver } from "@hookform/resolvers/yup";

import phoneNumberUpdateSchema from "../../../schema/phoneNumberUpdate";
import { updatePhoneNumberVerification } from "../../../service";
import PhoneNumberInputField from "../PhoneNumberInputField";
import { theme } from "../../../../theme";
import BtnSpinner from "../../../../common/BtnSpinner";
import { removePhoneNumberOtpResendCount } from "../../../../storage/phoneNumberOtpResendCount";

const PhoneNumberSubmit = ({ftm_id, handleCloseEdit, newDetails, setNewDetails}) => {
    const {
        handleSubmit,
        reset,
        formState: { errors },
        control,
    } = useForm({
        resolver: yupResolver(phoneNumberUpdateSchema),
    });

    const [isLoading, setIsLoading] = useState(false);

    const onSubmitPhoneNumber = async ({ ftm_contact_number }) => {
        try {
            setIsLoading(true);
            const response = await updatePhoneNumberVerification(ftm_id, ftm_contact_number);
            if (response.status === 'Success') {
                setIsLoading(false);
                handleCloseEdit();
                setNewDetails({ ...newDetails, phoneNumber: ftm_contact_number });

                removePhoneNumberOtpResendCount();
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.error('Error submitting phone number:', error);
        } finally {
            reset();
            setIsLoading(false);
        }
    };

    return (
        <form
            onSubmit={handleSubmit(onSubmitPhoneNumber)}
            className="m-2"
        >
            <div className="row gx-2 gx-sm-3 mb-3">
                <h5 className="mb-1 text-gradient text-dark">
                    PLEASE ENTER YOUR VALID PHONE NUMBER
                </h5>
                <p className="mb-2 text-sm">
                    Please enter your valid phone number to receive a new verification code.
                </p>
                <div className="col-12 col-md-12 mt-3">
                    <PhoneNumberInputField
                        control={control}
                        errors={errors}
                        hiddenTitel={true}
                        customClass="col-md-12"
                    />
                </div>
            </div>

            <div className="d-flex justify-content-center gap-2">
                <button
                    type="submit"
                    className={`btn btn-sm bg-gradient-${theme.main} w-100 my-4 mb-0`}
                    disabled={isLoading}
                >
                    {isLoading ? <BtnSpinner /> : 'SUBMIT'}
                </button>
                <button
                    className={`btn btn-sm bg-gradient-${theme.close_btn} w-100 my-4 mb-0`}
                    onClick={handleCloseEdit}
                    disabled={isLoading}
                >
                    {isLoading ? <BtnSpinner /> : 'CLOSE'}
                </button>
            </div>
        </form>
    );
};

export default PhoneNumberSubmit;